import axios, { AxiosError } from "axios";

// Models
import SeriesDTO from "../Models/DTOs/SeriesDTO";
import CountWrapper from "../Models/DTOs/CountWrapper";

// Constants
import config from "../Constants/Config";

const WEB_API_URL = process.env.REACT_APP_WEB_API_URL;
const WEB_API_BASE_URL = (WEB_API_URL ?? "").replace(/\/+$/, "");

export async function GetSeries(seriesId: number, abortController: AbortController) {
    const series = await axios
    .get(`${WEB_API_BASE_URL}/v1${config.series}/${seriesId}`, {
        signal: abortController.signal,
    })
    .then((result) => {
        let seriesResult = result.data as SeriesDTO;
        return seriesResult;
    })
    .catch((error: AxiosError) => {
        console.log("GetSeries");
        throw error;
    })

    return series;
};

export interface GetSeriesFeedArgs {
    take: number;
    skip: number;
    order?: "asc" | "desc";
    signal?: AbortSignal;
}

export async function GetSeriesFeed(
    args: GetSeriesFeedArgs
): Promise<CountWrapper<SeriesDTO>> {
    const { take, skip, order = "desc", signal } = args;

    return axios
        .get(`${WEB_API_URL}v1/series?take=${take}&skip=${skip}&order=${order}`, { signal })
        .then((result) => result.data as CountWrapper<SeriesDTO>)
        .catch((error: AxiosError) => {
            if ((error as any)?.name === "CanceledError") throw error;
            console.log("GetSeriesFeed error", error);
            throw error;
        });
}

export interface GetSeriesByCategoryArgs {
    categoryId: number;
    signal?: AbortSignal;
}

export async function GetSeriesByCategory(
    args: GetSeriesByCategoryArgs
): Promise<CountWrapper<SeriesDTO>> {
    const { signal, categoryId = 0 } = args;
    return axios
        .get(`${WEB_API_URL}v1${config.series}?categoryId=${categoryId}`, { signal })
        .then((result) => result.data as CountWrapper<SeriesDTO>)
        .catch((error: AxiosError) => {
            // Don’t log intentional cancels
            if ((error as any)?.name === "CanceledError") throw error;

            console.log("GetNewsSeries error", error);
            throw error;
        });
}
